import script from "./ParentElementSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentElementSelect.vue?vue&type=script&setup=true&lang=js"

import "./ParentElementSelect.vue?vue&type=style&index=0&id=50b56b8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b56b8e"]])

export default __exports__